import React from 'react';
import { motion } from 'framer-motion';
import { BRAND, HERO } from '../lib/content';
export function Hero() {
  return <section id="inicio" className="relative w-full overflow-hidden bg-[#F7F3EB] pt-6 sm:pt-10 pb-10 sm:pb-24" data-id="element-192" data-mp="ej4lxsz4c3dc">
      {/* Soft warm radial gradient background like the reference */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-white/60 via-transparent to-transparent" data-id="element-193" data-mp="4mi3tby6fqf0" />

      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center px-5 text-center sm:px-8" data-id="element-194" data-mp="127ect9b6vhbc">
        
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-col items-center w-full" data-id="element-195" data-mp="sbb5lp1hcshj">
          {/* Badge */}
          <span className="inline-flex justify-center items-center gap-1.5 rounded-full border border-navy-100 bg-white px-3 py-1.5 font-display text-[10px] font-extrabold uppercase tracking-[0.14em] text-navy shadow-sm sm:text-xs w-auto" data-id="element-196" data-mp="3d33cssqt6ji4">
            {HERO.badge}
          </span>

          {/* Headline */}
          <h1 className="mt-3 flex flex-col items-center font-display font-black leading-[0.8] tracking-tight" data-id="element-197" data-mp="3o5j4tesrxrnx">
            <span className="text-[5rem] text-orange sm:text-[8rem] md:text-[9.5rem]" style={{
            textShadow: '0px 6px 0px rgba(255, 140, 34, 0.15)'
          }} data-id="element-198" data-mp="39cpbapgo3b09">
              CHAU
            </span>
            <span className="text-[4.2rem] text-navy sm:text-[7rem] md:text-[8.5rem]" style={{
            textShadow: '0px 6px 0px rgba(21, 58, 115, 0.15)'
          }} data-id="element-199" data-mp="358rckfv9827q">
              CELULAR
            </span>
          </h1>

          {/* Subtitle & Description */}
          <div className="mt-4 max-w-3xl space-y-1" data-id="element-200" data-mp="2vjg4mwk3t3lf">
            <p className="font-display font-bold text-navy sm:text-3xl text-[16px]" data-id="element-201" data-mp="2hina4btsy8ib">
              En menos de 10 minutos, tu hijo puede estar construyendo <span className="text-orange" data-id="element-202" data-mp="2lk8vklkejv44">su primer robot en casa.</span> con materiales que ya tenés en casa.
            </p>
            <p className="mx-auto max-w-2xl font-bold text-navy/60 sm:text-xl text-[12px]" data-id="element-203" data-mp="s3ur9xru3ab5">
              Transformá el tiempo frente a las pantallas en horas de creatividad, aprendizaje y diversión.
            </p>
          </div>
        </motion.div>

        {/* Product Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mt-5 w-full max-w-4xl" data-id="element-204" data-mp="deyjm1tovzb2">
          <div className="relative overflow-hidden rounded-[2rem] shadow-2xl sm:rounded-[3rem]" data-id="element-205" data-mp="111yc0ruzw31w">
            <motion.img src="https://cdn.magicpatterns.com/uploads/4FociB8BRDSrpB6daRb3WA/5513c5ea-3799-407d-805b-5123f040015b.webp" alt="Mini Constructores mostrado en libro, laptop, tablet y celular junto a robots" className="w-full object-cover" animate={{
            y: [0, -12, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: "easeInOut"
          }} data-id="element-206" data-mp="x1ny8t0yo8ch" />
            
            {/* Floating Badges */}
            <div className="absolute left-2 top-[45%] sm:left-4 sm:top-[50%]" data-id="element-207" data-mp="218tntq0zt0c8">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 font-display text-[10px] font-extrabold text-navy shadow-lg sm:text-xs" data-id="element-208" data-mp="268g282sk4mmm">
                <span className="text-orange" data-id="element-209" data-mp="2g0lpx0bs0hw0">▶</span> Videos paso a paso
              </span>
            </div>
            
            <div className="absolute bottom-8 right-2 sm:bottom-12 sm:right-4" data-id="element-210" data-mp="2kxknxtyk98zh">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 font-display text-[10px] font-extrabold text-navy shadow-lg sm:text-xs" data-id="element-211" data-mp="2p1jylvx5tdkx">
                <span className="text-orange text-sm leading-none" data-id="element-212" data-mp="umprg5n05t0l">∞</span> Acceso para siempre
              </span>
            </div>
          </div>
        </motion.div>

      </div>
    </section>;
}